module.exports = __webpack_public_path__ + "static/media/fp-1.4b981c8c.jpg";